/** True when session allows multiple plays (from login API). */
export function isMultiplaySession(user) {
  return user?.isMultiplaySession === true || user?.isMultiplaySession === "true";
}

/** Strip attempt suffix `base_0` → `base`. */
export function baseUserId(id) {
  const s = String(id ?? "").trim();
  const m = s.match(/^(.+)_(\d+)$/);
  return m ? m[1] : s;
}

export function getAuthBaseUserId(user) {
  return baseUserId(user?.userId || user?.id || "");
}

function attemptStorageKey(user) {
  return `spotAttempt_${user.sessionId}_${getAuthBaseUserId(user)}`;
}

/** userId sent to spotSubmit: `id_0`, `id_1`, … when multiplay. */
export function getNextSubmitUserId(user) {
  const base = getAuthBaseUserId(user);
  if (!base) return "";
  if (!isMultiplaySession(user)) return base;
  const key = attemptStorageKey(user);
  const attempt = Number(sessionStorage.getItem(key) || 0);
  return `${base}_${attempt}`;
}

export function bumpAttemptAfterSubmit(user) {
  if (!isMultiplaySession(user)) return;
  const key = attemptStorageKey(user);
  const n = Number(sessionStorage.getItem(key) || 0);
  sessionStorage.setItem(key, String(n + 1));
}

/** Sync sessionStorage counter after server assigns submittedUserId (e.g. base_2). */
export function syncAttemptFromSubmittedId(user, submittedUserId) {
  if (!isMultiplaySession(user)) return;
  const m = String(submittedUserId || "").match(/_(\d+)$/);
  if (!m) return;
  const key = attemptStorageKey(user);
  sessionStorage.setItem(key, String(parseInt(m[1], 10) + 1));
}
